import { acceptHMRUpdate, defineStore } from 'pinia'
import type { AdminSettings } from '~/types/prisma'

export enum SettingIdByDescription {
  EnableLeaderboard = '1',
  EnableRaffles = '2',
  EnableTeamChanges = '3',
  CurrentYear = '4',
  SelectYear = '5',
  EnableAuctionItems = '6',
  yearNumber = "7",
  yearName = "8",
  MaintenanceMode = '9',
  Registration = '10'
}

export function settingsArrayToRecord(settingsArray: AdminSettings[]) {
  return settingsArray.reduce((acc, curr) => ({
    ...acc,
    [curr.id]: curr,
  }), {} as Record<SettingIdByDescription, AdminSettings>)
}

export const useSettingsStore = defineStore('settings', () => {
  const year = ref(new Date().getFullYear())
  const globalEvent = ref()
  const settings = ref<Record<SettingIdByDescription, AdminSettings>>({} as Record<SettingIdByDescription, AdminSettings>)

  function setSettings(settingsArray: AdminSettings[]) {
    const settingsRecord = settingsArrayToRecord(settingsArray)
    settings.value = settingsRecord
    year.value = settingsRecord[SettingIdByDescription.SelectYear]?.value ?? new Date().getFullYear()
  }

  function setYear(yearFromSettings: number) {
    year.value = yearFromSettings
  }

  function setGlobalEvent(eventId: string) {
    globalEvent.value = eventId
  }

  return {
    year,
    globalEvent,
    settings,
    setYear,
    setGlobalEvent,
    setSettings,
  }
})

if (import.meta.hot)
  import.meta.hot.accept(acceptHMRUpdate(useSettingsStore, import.meta.hot))
